export default "__VITE_ASSET__qI34rTpo__"